import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import 'rxjs/operators';
import { catchError, map } from 'rxjs/operators';
import { TenantAPIService } from 'src/app/extensions/services/api/tenant-api.service';
import { deepMerge } from '../../../extensions/utilities';

export class TranslateServerLoader implements TranslateLoader {
  constructor(
    private _tenantAPIService: TenantAPIService,
    private _http: HttpClient
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const localTranslations$ = this._http.get(`/assets/i18n/${lang}.json`).pipe(
      catchError(error => {
        // Log a warning for developers, but don't break the app
        console.warn(
          `Could not find local translation file: /assets/i18n/${lang}.json. Proceeding with remote translations only.`
        );
        // Return an empty object to allow the remote translations to load
        return of({});
      })
    );

    const tenantTranslations$ = this._tenantAPIService
      .getTenantTranslation(lang)
      .pipe(
        map(x => {
          return x?.data ? JSON.parse(x.data) : null;
        })
      )
      .pipe(
        catchError(error => {
          console.error('Error fetching remote translations. Falling back to local only.', error);
          // If API fails, return an empty object to not break the merge
          return of({});
        })
      );

    // Use forkJoin to wait for both observables to complete
    return forkJoin([localTranslations$, tenantTranslations$]).pipe(
      map(([localTranslations, tenantTranslations]) => {
        // Merge the local and remote translations
        // The remote translations will override the local ones for common keys
        // We use a deep merge to handle nested JSON objects

        const merged = deepMerge(localTranslations, tenantTranslations);
        return merged;
      })
    );
  }
}

export function HttpLoaderFactory(tenantApiService: TenantAPIService, http: HttpClient) {
  return new TranslateServerLoader(tenantApiService, http);
}
